// Which ODD stage a tenant's Prevent (tenantSettings.bugsProd) or Plan
// (tenantSettings.bsaProd) reads. The rows hold "prod", "dev" or "dev2"
// (STRY0039057); rows written before that hold a boolean. Same rule as the
// backend's tools.odd.base_url.odd_stage_from_value.

export const ODD_STAGES = ['prod', 'dev', 'dev2'];

// The super-admin choice, in the order it is offered.
export const ODD_STAGE_CHOICES = [
  { value: 'prod', label: 'Production' },
  { value: 'dev', label: 'dev' },
  { value: 'dev2', label: 'dev2' }
];

// Short labels for the Plan environment indicator.
export const ODD_STAGE_SHORT_LABEL = { prod: 'Prod', dev: 'Dev', dev2: 'Dev2' };

/**
 * The stage a stored setting value means. A missing row, null or anything
 * unrecognised is prod; legacy true is prod and false is dev.
 * @param {*} value - tenantSettings row value.value
 * @returns {'prod'|'dev'|'dev2'}
 */
export const oddStageOf = value => {
  if (value === false) return 'dev';
  if (typeof value === 'string') {
    const stage = value.trim().toLowerCase();
    if (ODD_STAGES.includes(stage)) return stage;
  }
  return 'prod';
};
